import {API} from "../../../api/api";
import {GamesAPIRoutes} from "./apiRoutes";

const getGameEngines = () => {
    return API.request({
        routeID: GamesAPIRoutes.GET_GAME_ENGINES,
        odataParameters: {
            skip: 0,
            top: 10000
        }
    });
};

const getGameEnginesSchemas = () => {
    return API.request({
        routeID: GamesAPIRoutes.GET_GAME_ENGINES_SCHEMAS,
        odataParameters: {
            skip: 0,
            top: 10000
        }
    });
};

const getGameConfigs = ({skip, top, search, gameId}) => {
    let parameters = [];
    Object.keys(search).map(key => {
        if (key == "subsidiary" && search[key].length > 0)
            parameters.push(`subsidiary_id in (${search[key]
                .map(c => c)
                .join(",")},)`);
        /*else if (key == "gameEngine" && search[key].length > 0)
            parameters.push(`engine_version_id in ${search[key]}`);*/ else if (
            key == "status" &&
            search[key].length > 0
        )
            parameters.push(`active eq ${search[key]}`);
    });

    parameters.push(`game_id eq ${gameId}`);

    let filter = parameters.join(" and ");
    return API.request({
        routeID: GamesAPIRoutes.GET_GAME_CONFIGS,
        odataParameters: {
            skip,
            top,
            filter: filter,
            orderby: "-id"
        }
    });
};

const getSubsidiaryConfigs = subsidiary => {
    return API.request({
        routeID: GamesAPIRoutes.GET_GAME_CONFIGS,
        odataParameters: {
            skip: 0,
            top: 1000000,
            filter: `subsidiary in ${subsidiary} and active eq true`,
            orderby: "-id"
        }
    });
};

const getGames = ({skip, top, search, type, software_house, deprecated}) => {
    let parameters = [];
    if (type && type !== "") {
        parameters.push(`product_type_id in (${type.map(c => c).join(",")},)`);
    }

    if (software_house && software_house !== "") {
        parameters.push(`software_house_id eq ${software_house}`);
    }

    if (deprecated && deprecated !== "") {
        parameters.push(`deprecated eq ${deprecated == 0 ? "true" : "false"}`);
    }

    //if(search && search !== '') {
    //    parameters.push(`trademark__name__contains('${search}') or name in '${search}'`);
    //}

    let filter = parameters.join(" and ");
    return API.request({
        routeID: GamesAPIRoutes.GET_GAMES,
        odataParameters: {
            skip,
            top,
            filter: filter,
            search: search,
            orderby: "id"
        }
    });
};

/*const getGameConfiguration = gameId => {
    return API.request({
        routeID: GamesAPIRoutes.GET_GAME_CONFIGURATION,
        routeParameters: {
            config_id: gameId
        }
    });
};*/

const getSubsidiaries = () => {
    const odataParameters = {
        skip: 0,
        top: 10000
    };
    return API.request({
        routeID: GamesAPIRoutes.GET_SUBSIDIARIES,
        odataParameters
    });
};

const editGame = game => {
    return API.request({
        routeID: GamesAPIRoutes.EDIT_GAME,
        routeParameters: {
            game_id: game.id
        },
        parameters: game
    });
};

const createGame = game => {
    return API.request({
        routeID: GamesAPIRoutes.ADD_GAME,
        parameters: game
    });
};

const getGame = gameId => {
    return API.request({
        routeID: GamesAPIRoutes.GET_GAME,
        routeParameters: {
            game_id: gameId
        }
    });
};

const editConfiguration = conf => {
    return API.request({
        routeID: GamesAPIRoutes.EDIT_CONFIGURATION,
        routeParameters: {
            config_id: conf.configuration.id
        },
        parameters: conf,
        formData: false
    });
};

const createConfiguration = conf => {
    return API.request({
        routeID: GamesAPIRoutes.ADD_CONFIGURATION,
        parameters: conf,
        formData: false
    });
};

const deleteConfiguration = id => {
    return API.request({
        routeID: GamesAPIRoutes.DELETE_CONFIGURATION,
        routeParameters: {
            config_id: id
        }
    });
};

const getGameBundles = ({skip, top, search}) => {
    return API.request({
        routeID: GamesAPIRoutes.GET_BUNDLES,
        odataParameters: {
            skip,
            top,
            search: search,
            orderby: "name"
        }
    });
};

const editBundle = bundle => {
    return API.request({
        routeID: GamesAPIRoutes.EDIT_BUNDLE,
        routeParameters: {
            bundle_id: bundle.id
        },
        parameters: bundle,
        formData: false
    });
};

const createBundle = bundle => {
    return API.request({
        routeID: GamesAPIRoutes.ADD_BUNDLE,
        parameters: bundle,
        formData: false
    });
};

const deleteBundle = id => {
    return API.request({
        routeID: GamesAPIRoutes.DELETE_BUNDLE,
        routeParameters: {
            bundle_id: id
        }
    });
};

const loadJson = json => {
    return API.request({
        routeID: GamesAPIRoutes.LOAD_JSON,
        parameters: json,
        formData: false
    });
};

const createAlias = alias => {
    return API.request({
        routeID: GamesAPIRoutes.CREATE_ALIAS,
        parameters: {
            matches: alias
        },
        formData: false
    });
};

const activateConfiguration = configurationId => {
    return API.request({
        routeID: GamesAPIRoutes.ACTIVATE_CONFIGURATION,
        routeParameters: {
            game_configuration_id: configurationId
        }
    });
};

const getGameFeatures = (client = undefined) => {
    let filter = ''
    if (client !== undefined && client !== null) {
        filter = `client_id eq ${client}`
    }

    return API.request({
        routeID: GamesAPIRoutes.GET_GAME_FEATURES,
        odataParameters: {
            filter: filter,
            orderby: "feature_id"
        }
    });
};

const getGameSeries = (client = undefined) => {
    let filter = ''
    if (client !== undefined && client !== null) {
        filter = `client_id eq ${client}`
    }

    return API.request({
        routeID: GamesAPIRoutes.GET_GAME_SERIES,
        odataParameters: {
            filter: filter,
            orderby: "series_id"
        }
    });
};

const getGamePlatforms = (client = undefined) => {
    let filter = ''
    if (client !== undefined && client !== null) {
        filter = `client_id eq ${client}`
    }

    return API.request({
        routeID: GamesAPIRoutes.GET_GAME_PLATFORMS,
        odataParameters: {
            filter: filter,
            orderby: "platform_id"
        }
    });
};

const getGameTypes = (client = undefined) => {
    let filter = ''
    if (client !== undefined && client !== null) {
        filter = `client_id eq ${client}`
    }

    return API.request({
        routeID: GamesAPIRoutes.GET_GAME_TYPES,
        odataParameters: {
            filter: filter,
            orderby: "trademark_id"
        }
    });
};

const getGameTrademarks = (client = undefined) => {
    let filter = ''
    if (client !== undefined && client !== null) {
        filter = `client_id eq ${client}`
    }

    return API.request({
        routeID: GamesAPIRoutes.GET_GAME_TRADEMARKS,
        odataParameters: {
            filter: filter,
            orderby: "trademark_id"
        }
    });
};

const getClients = () => {
    return API.request({
        routeID: GamesAPIRoutes.GET_CLIENTS,
        formData: false
    });
};

const editGameAttribute = editAttr => {
    let attr = {...editAttr};
    let id = editAttr.id;
    let key = editAttr.key;
    attr[key] = editAttr.attr_id;
    delete attr.id;
    delete attr.attr_id;
    delete attr.key;

    let route = '';
    switch (key) {
        case "series_id":
            attr.id = attr.series_id
            delete attr.series_id
            route = GamesAPIRoutes.EDIT_GAME_SERIES;
            break;
        case "trademark_id":
            attr.id = attr.trademark_id
            delete attr.trademark_id
            route = GamesAPIRoutes.EDIT_GAME_TRADEMARKS;
            break;
        case "feature_id":
            attr.id = attr.feature_id
            delete attr.feature_id
            route = GamesAPIRoutes.EDIT_GAME_FEATURES;
            break;
        case "platform_id":
            attr.id = attr.platform_id
            delete attr.platform_id
            route = GamesAPIRoutes.EDIT_GAME_PLATFORMS;
            break;
        case "type_id":
            attr.id = attr.type_id
            delete attr.type_id
            route = GamesAPIRoutes.EDIT_GAME_TYPES;
            break;
        default:
            break;
    }

    return API.request({
        routeID: route,
        routeParameters: {
            id: id
        },
        parameters: attr,
        formData: false
    });
};

const createGameAttribute = createAttr => {
    let attr = {...createAttr};
    let key = createAttr.key;
    attr[key] = createAttr.attr_id;
    delete attr.attr_id;
    delete attr.key;

    let route = "";
    switch (key) {
        case "series_id":
            attr.id = attr.series_id
            delete attr.series_id
            route = GamesAPIRoutes.CREATE_GAME_SERIES;
            break;
        case "trademark_id":
            attr.id = attr.trademark_id
            delete attr.trademark_id
            route = GamesAPIRoutes.CREATE_GAME_TRADEMARKS;
            break;
        case "feature_id":
            attr.id = attr.feature_id
            delete attr.feature_id
            route = GamesAPIRoutes.CREATE_GAME_FEATURES;
            break;
        case "platform_id":
            attr.id = attr.platform_id
            delete attr.platform_id
            route = GamesAPIRoutes.CREATE_GAME_PLATFORMS;
            break;
        case "type_id":
            attr.id = attr.type_id
            delete attr.type_id
            route = GamesAPIRoutes.CREATE_GAME_TYPES;
            break;
        default:
            break;
    }

    return API.request({
        routeID: route,
        parameters: attr,
        formData: false
    });
};


export const gamesAPI = {
    getGameEngines,
    getGameConfigs,
    getSubsidiaries,
    //getGameConfiguration,
    getGameEnginesSchemas,
    getGames,
    getGame,
    createGame,
    editGame,
    createConfiguration,
    editConfiguration,
    deleteConfiguration,
    getGameBundles,
    createBundle,
    editBundle,
    getSubsidiaryConfigs,
    deleteBundle,
    loadJson,
    createAlias,
    activateConfiguration,
    getGameFeatures,
    getGameSeries,
    getGamePlatforms,
    getGameTypes,
    getGameTrademarks,
    getClients,
    editGameAttribute,
    createGameAttribute
};
